// The chat timestamp shape, kept out of the bubble so the component holds no date assembly.
//
// old renders `5:01 PM · Aug 25` under every turn (`OrpheusChatArea.vue:860`
// `formatMessageTimestamp`): a 12-hour clock reading, a middle dot, then a year-less calendar day.
// That is not any single `Intl` preset — `dateStyle` always carries a year and `withTime` always
// leads with the date — so it is composed from two shared-formatter calls here. The separator is a
// typographic glyph, not translatable copy; the two halves are locale-aware on their own.
import type { Formatter } from '@/shared/lib/format'

const SEPARATOR = ' · '

/**
 * `''` for a turn with no timestamp — old hid the row entirely in that case
 * (`hasMessageTimestamp`), rather than showing a placeholder dash.
 */
export function messageStamp(value: string | null | undefined, format: Formatter): string {
  if (value === null || value === undefined || value.trim() === '') return ''
  return `${format.formatTime(value, { hour12: true })}${SEPARATOR}${format.formatDate(value, {
    omitYear: true,
  })}`
}
